import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import chevronLeft from '@iconify-icons/mdi/chevron-left'
import LicenseTable from '../../../components/LicenseTable'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGetUserDetailsQuery, useUpdateIsStudentMutation } from '../../../redux/api/userDetailsApi'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Profile: React.FC = () => {
    const location = useLocation()
    const userDetails = useGetUserDetailsQuery({})
    const navigate = useNavigate()
    const [currentTab, setCurrentTab] = useState('Profile Details')
    const [isStudent, setIsStudent] = useState(false)
    const [updateIsStudent] = useUpdateIsStudentMutation()

    const labels = ['First Name', 'Last Name', 'Email', 'Company/Institution Name', 'Telephone', 'Address']

    const mode = location?.state?.mode

    const isStudentUser = localStorage.getItem('isStudentUser')
    const isNormalUser = localStorage.getItem('isNormalUser')
    const isBlockedUser = localStorage.getItem('isBlockedUser')
    const showPurchaseRequests = mode === undefined && isNormalUser === 'true' && isBlockedUser === 'true' && isStudentUser !== 'true'

    const tabs = !showPurchaseRequests ? ['Profile Details', 'Purchase Requests'] : ['Profile Details']

    useEffect(() => {
        if (userDetails?.data?.data) {
            const userInfo = userDetails.data.data
            setIsStudent(userInfo.isStudent)
        }
    }, [userDetails])

    const handleCheckboxChange = async () => {
        const newState = !isStudent
        setIsStudent(newState)

        try {
            await updateIsStudent(newState).unwrap()
            console.log('Successfully updated isStudent:', newState)
        } catch (error) {
            console.error('Failed to update isStudent:', error)
        }
    }

    useEffect(() => {
        if (currentTab === 'Profile Details') {
            userDetails.refetch()
        }
    }, [currentTab])

    const userInfo = userDetails?.data?.data || {}

    return (
        <div className='w-full px-8 py-4 text-center bg-white'>
            <div className='px-4 py-8 mx-auto space-y-6 bg-[#f9f9f9] rounded-lg'>
                <h1 className='text-2xl font-semibold flex items-center'>
                    <Icon
                        icon={chevronLeft}
                        style={{ fontSize: '32px' }}
                        color='black'
                        className='text-red-900 cursor-pointer mr-2'
                        onClick={() => {
                            navigate(-1)
                        }}
                    />
                    My Profile
                </h1>
                <div className='flex items-center mb-4 border border-lightGray rounded-lg w-fit'>
                    {tabs.map((statusValue, index, array) => (
                        <button
                            key={statusValue}
                            onClick={() => setCurrentTab(statusValue)}
                            className={`px-10 py-2 font-semibold ${
                                currentTab === statusValue ? 'bg-lightBlue text-blue' : 'text-grey-400'
                            } ${index === 0 ? 'rounded-l-lg' : ''} ${index === array.length - 1 ? 'rounded-r-lg' : ''} ${
                                index !== array.length - 1 ? 'border-r border-lightGray' : ''
                            }`}
                        >
                            {statusValue}
                        </button>
                    ))}
                </div>
                {currentTab === 'Purchase Requests' && <LicenseTable currentTab={currentTab} />}
                {currentTab === 'Profile Details' && (
                    <div className='bg-white rounded-lg p-6'>
                        <div className='border border-gray rounded-lg p-6' style={{ borderWidth: '2px' }}>
                            <div className='flex items-center justify-between mb-6'>
                                <h1 className='text-2xl font-semibold'>Your Information</h1>
                            </div>
                            {userDetails.isLoading ? (
                                <>
                                    <div className='flex gap-4 mb-4 text-left'>
                                        {labels.slice(0, 3).map((label, i) => (
                                            <div key={i} className='flex-1 space-y-4'>
                                                <p className='text-lg text-secondary font-semibold'>{label}</p>
                                                <Skeleton height={24} />
                                            </div>
                                        ))}
                                    </div>
                                    <div className='flex gap-4 text-left'>
                                        {labels.slice(3).map((label, i) => (
                                            <div key={i} className='flex-1 space-y-4'>
                                                <p className='text-lg text-secondary font-semibold'>{label}</p>
                                                <Skeleton height={24} />
                                            </div>
                                        ))}
                                    </div>
                                    <div className='flex items-center mt-8'>
                                        <Skeleton width={200} height={24} />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='flex gap-4 mb-4 text-left'>
                                        {labels.slice(0, 3).map((label, i) => (
                                            <div key={i} className='flex-1 space-y-4'>
                                                <p className='text-lg text-secondary font-semibold'>{label}</p>
                                                <p className='text-lg text-black'>{userInfo[Object.keys(userInfo)[i]] || '-'}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='flex gap-4 text-left'>
                                        {labels.slice(3).map((label, i) => (
                                            <div key={i} className='flex-1 space-y-4'>
                                                <p className='text-lg text-secondary font-semibold'>{label}</p>
                                                <p className='text-lg text-black'>{userInfo[Object.keys(userInfo)[i + 3]] || '-'}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='flex items-center mt-8'>
                                        <label className='relative flex items-center text-primary gap-2 text-xl'>
                                            <input
                                                type='checkbox'
                                                checked={isStudent}
                                                onChange={handleCheckboxChange}
                                                className='sr-only'
                                            />
                                            <span
                                                className={`w-4 h-4 flex justify-center items-center rounded border ${
                                                    isStudent ? 'bg-primary' : 'bg-white border-gray-300'
                                                }`}
                                            >
                                                {isStudent && (
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        viewBox='0 0 24 24'
                                                        fill='none'
                                                        stroke='white'
                                                        strokeWidth='2'
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        className='w-4 h-4'
                                                    >
                                                        <path d='M5 13l4 4L19 7' />
                                                    </svg>
                                                )}
                                            </span>
                                            <span className='text-lg ml-2'>Are you a student?</span>
                                        </label>
                                        <Icon
                                            icon={'line-md:edit-twotone'}
                                            className='text-secondary ml-4 cursor-pointer'
                                            width={20}
                                            height={20}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                console.log('Edit icon clicked')
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Profile
